import Vue from 'vue';
import Router from 'vue-router';

import PublicRoutes from './routes/public';
import AuthRoutes from './routes/auth';

import store from './vuex/store';

Vue.use(Router);

const routes = PublicRoutes.concat(AuthRoutes);
// const routes = PublicRoutes.concat(AuthRoutes, TestRoutes);

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const meta = _.pick(to.meta, ['title', 'description']);
  meta.path = to.path === '/landing' ? '/' : to.path;
  store.dispatch('updateMeta', meta);

  // console.log('router.beforeEach', to, from, next);

  // console.log(store.state.nav.nav);

  // Bus.$emit('init_gui');

  next();
});

export default router;
